var map = {
	"./categories-preview": 82160,
	"./categories-preview/": 82160,
	"./categories-preview/10542.png": 98888,
	"./categories-preview/11450.png": 91000,
	"./categories-preview/11700.png": 42888,
	"./categories-preview/12.png": 50684,
	"./categories-preview/13587.png": 2584,
	"./categories-preview/2.png": 3496,
	"./categories-preview/20.png": 81948,
	"./categories-preview/2000.png": 72252,
	"./categories-preview/281.png": 67600,
	"./categories-preview/293.png": 75632,
	"./categories-preview/2984.png": 66112,
	"./categories-preview/3000.png": 97068,
	"./categories-preview/5000.png": 26376,
	"./categories-preview/6000.png": 54628,
	"./categories-preview/7000.png": 56652,
	"./categories-preview/8000.png": 93196,
	"./categories-preview/888.png": 72048,
	"./categories-preview/index": 82160,
	"./categories-preview/index.js": 82160,
	"./categories-preview/subcategory.png": 91952,
	"./cryptocurrencies.svg": 64596,
	"./direct-delivery-icon-active.png": 48388,
	"./direct-delivery-icon.png": 54100,
	"./direct-delivery.png": 54568,
	"./logo-small.svg": 84932,
	"./logo.svg": 69532,
	"./logo_compact.png": 89084,
	"./offer-active.png": 54183,
	"./offer.png": 31492,
	"./pickup-point-active.png": 69868,
	"./pickup-point.png": 68220,
	"./pkoin.svg": 76284,
	"./self-pickup-icon-active.png": 33496,
	"./self-pickup-icon.png": 70256,
	"./self-pickup.png": 47972,
	"./social.svg": 88916
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50748;